/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardViewState extends models.ViewState {
    constructor() {
        super();
        this.setDiscriminator("DashboardViewState");
    }

    getFixupPrototypeFunction() { return DashboardViewState.fixupPrototype; }

    static newInstance(model: Partial<DashboardViewState>): DashboardViewState {
        let obj = Object.assign(new DashboardViewState(), model);
        DashboardViewState.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardViewState>): DashboardViewState {
        if (!model) return null;
        return DashboardViewState.newInstance(<DashboardViewState> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardViewState) {
        if (!obj) return;

        models.DashboardViewState.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardViewState): boolean {
        if (models.ViewState.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DashboardViewState.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.widgets) {
            for (let val of this.widgets) {
                models.WidgetViewState.fixupPrototype(val);
            }
        }
    }

    widgets: Array<models.WidgetViewState>;

}
